var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 3.16504C27.7457 3.16504 34.8356 10.255 34.8356 19.0008C34.8356 27.7467 27.7457 34.8366 18.9999 34.8366C10.254 34.8366 3.16406 27.7467 3.16406 19.0008C3.16406 10.255 10.254 3.16504 18.9999 3.16504ZM18.9938 16.2285C18.1818 16.229 17.513 16.8407 17.4221 17.6282L17.4115 17.8128L17.4172 26.5237L17.428 26.7083C17.52 27.4957 18.1896 28.1065 19.0016 28.106C19.8136 28.1055 20.4824 27.4938 20.5734 26.7063L20.5839 26.5216L20.5782 17.8108L20.5674 17.6261C20.4754 16.8387 19.8058 16.2279 18.9938 16.2285ZM19.0006 10.2917C17.9062 10.2917 17.019 11.1789 17.019 12.2732C17.019 13.3676 17.9062 14.2548 19.0006 14.2548C20.095 14.2548 20.9821 13.3676 20.9821 12.2732C20.9821 11.1789 20.095 10.2917 19.0006 10.2917Z",
    fill: "#EB5757"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoRed);
export default __webpack_public_path__ + "static/media/info-red.4c5222ea2e1a5b633edd5d6e8a06da39.svg";
export { ForwardRef as ReactComponent };